module.exports = __webpack_public_path__ + "static/media/th.3c84849d.svg";